import axios from "./axiosAuthRequired"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const getRecommendedTasks = async (game, time, update) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/user/tasks/recommended`
    const config = {
      params: {
        time,
        game: game,
        update: !!update,
      },
      headers: {
        "Authorization": "Bearer " + clientCredentials,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const setTaskCompletion = async (taskId, body) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/user/tasks/${taskId}/set-completion`
    const config = {
      headers: {
        "Authorization": "Bearer " + clientCredentials,
      },
    }
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const closeWeeklyTaskNotification = async (taskListId) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/user/task-lists/${taskListId}/close`
    const config = {
      headers: {
        "Authorization": "Bearer " + clientCredentials,
      },
    }
    const res = await axios.put(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/task.js